import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ControlLabel, FormGroup, FormControl } from 'react-bootstrap';

import validation from '../../lib/validation';
import { updateField } from '../../actions/form';

export class FieldSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { validationState: null };

    /* istanbul ignore next */
    this.onSelectChange = this.onSelectChange.bind(this);
    this.getValue = this.getValue.bind(this);
  }

  componentDidMount() {
    if (_.has(this.props, 'selectedDefaultValue') && !this.props.fieldValue) {
      this.props.updateField(this.props.type, this.props.field, _.toString(this.props.selectedDefaultValue));
      this.validateInput(this.props.fieldValue);
    }

    if (!_.isEmpty(this.props.fieldValue)) {
      this.validateInput(this.props.fieldValue);
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.state.isFocused && this.props.fieldValue !== prevProps.fieldValue) {
      this.validateInput(this.props.fieldValue);
    }
  }

  onSelectChange(event) {
    this.props.updateField(this.props.type, this.props.field, event.target.value);
  }

  validateInput(value) {
    if (!_.isEmpty(value) || _.get(this.props, 'validation.required')) {
      this.setState({ validationState: validation.run(this.props.validation, _.toString(value)) ? 'success' : 'error' });
    } else {
      this.setState({ validationState: null });
    }
  }

  getValue() {
    // if otherOption is set, and the fieldValue from the store is not empty
    // and not found in the available options array, return the value of otherOption
    if (this.props.otherOption
        && !_.isEmpty(this.props.fieldValue)
        && !_.find(this.props.options, { slug: this.props.fieldValue })) {
      return this.props.otherOption;
    }

    return this.props.fieldValue;
  }

  renderSelectOptions() {
    const options = [...this.props.options];

    if (this.props.defaultEmptyOption) {
      options.unshift({ slug: '', value: this.props.defaultEmptyOption });
    }

    if (this.props.otherOption) {
      options.push({ slug: 'Other', value: this.props.otherOption });
    }

    return _.map(options, option => (
      <option key={option.slug} value={option.slug}>
        {option.value}
      </option>
    ));
  }

  render() {
    return (
      <FormGroup
        className={ `dropdownSelect ${this.props.rating ? 'rating' : ''}` }
        controlId={this.props.field}
        validationState={this.state.validationState}
      >
        <FormControl
          className="comboBoxControl"
          value={this.getValue()}
          componentClass="select"
          onChange={this.onSelectChange}
          disabled={this.props.disabled}
        >
          {this.renderSelectOptions()}
        </FormControl>
        <FormControl.Feedback className={`${this.props.rating ? 'rating-select-feedback' : 'select-feedback'}`} />
        <ControlLabel className="glyphicon glyphicon-chevron-down dropdown-arrow" />
      </FormGroup>
    );
  }
}

export const mapStateToProps = (state, ownProps) => ({
  fieldValue: _.get(state, `form.${state.ui.ratingType}.fields.${ownProps.field}`),
  type: _.get(state, 'ui.ratingType'),
  validation: _.get(state, `form.validation.${state.ui.ratingType}.${state.ui.formType}.fields.${ownProps.field}`),
});

export default connect(
  mapStateToProps,
  { updateField },
)(FieldSelect);

FieldSelect.propTypes = {
  disabled: PropTypes.bool,
  field: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  otherOption: PropTypes.string,
};
